import { submitLap, type SubmitLapResult } from '../server/laps';
import { isAssistedMode, type RaceMode } from './DrivingAssists';
import type { GhostRecording } from '../timing/Ghost';

export interface SubmitLapIfEligibleInput {
  devMode: boolean;
  raceMode: RaceMode;
  backendConfigured: boolean;
  trackId: string;
  totalMs: number;
  sectors: [number, number, number];
  ghost: GhostRecording | null;
}

export type SubmitLapIfEligibleResult =
  | { submitted: true; result: SubmitLapResult }
  | { submitted: false; reason: 'devMode' | 'assisted' | 'backendUnconfigured' };

/** Submits the lap if it's eligible — every lap goes up, not just personal
 *  bests, so the backend has the full dataset. The three skip cases match
 *  the historical guards in bootstrap. */
export async function submitLapIfEligible(
  input: SubmitLapIfEligibleInput,
): Promise<SubmitLapIfEligibleResult> {
  if (input.devMode) return { submitted: false, reason: 'devMode' };
  if (isAssistedMode(input.raceMode)) return { submitted: false, reason: 'assisted' };
  if (!input.backendConfigured) return { submitted: false, reason: 'backendUnconfigured' };

  const result = await submitLap({
    trackId: input.trackId,
    totalMs: input.totalMs,
    sectorMs: input.sectors,
    ghost: input.ghost,
  });
  return { submitted: true, result };
}
